import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import './Layout.css';

const Layout = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="layout">
      {mobileOpen && (
        <div
          className="layout-overlay"
          onClick={() => setMobileOpen(false)}
        />
      )}

      <Sidebar
        mobileOpen={mobileOpen}
        onMobileClose={() => setMobileOpen(false)}
        collapsed={collapsed}
        onCollapse={() => setCollapsed(c => !c)}
      />

      <div className={`layout-content ${collapsed ? 'sidebar-collapsed-offset' : 'sidebar-full-offset'}`}>
        <Topbar onMenuClick={() => setMobileOpen(o => !o)} />
        <main className="layout-main">
          <div className="layout-container">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default Layout;